import { Expose, Type } from 'class-transformer';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class ProductVariantModel {
  id: string;
  name: string;
  description: string;

  @Expose({ name: 'sell_price' })
  @Type(() => Number)
  sellPrice: number;

  @Type(() => Number)
  stock: number;

  @Expose({ name: 'average_price' })
  @Type(() => Number)
  averagePrice: number;
}

export class ProductAdjustmentItemModel {
  id: string;
  type: string;
  description: string;

  @Expose({ name: 'complete_name' })
  completeName: string;

  @Expose({ name: 'product_variant' })
  @Type(() => ProductVariantModel)
  productVariant: ProductVariantModel;

  @Type(() => Number)
  qty: number;

  @Type(() => Number)
  price: number;
}

// show
export class ProductAdjustmentModel {
  id: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  number: string;
  description: string;

  @Expose({ name: 'product_adjustment_items' })
  @Type(() => ProductAdjustmentItemModel)
  productAdjustmentItems: ProductAdjustmentItemModel[];
}

// list
export class ProductAdjustmentLiteModel extends CommonModel {
  number: string;
  description: string;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;
}

// query
export type getProductsAdjustmentInput = {
  params: CommonParamInput;
};

export type getProductAdjustmentInput = {
  id: string;
};

// mutation
export class ProductAdjustmentItemMutationInput {
  productVariantId: string;
  type: string;
  description: string;
  qty: number;
  price: number;
}

export class ProductAdjustmentMutationInput {
  transactionAt: Date;
  description?: string;
  items: ProductAdjustmentItemMutationInput[];
}

export type ProductAdjustmentMutationUpdateInput = {
  id: string;
  body: ProductAdjustmentMutationInput;
};

export type ProductAdjustmentMutationDeleteInput = {
  id: string;
};
